/**
 * @file 产品全景 的 api
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApi';

// 获取paddlehub首页数据
export const fetchGetOverview = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/paddleoverview'})
            .query(window.location.search.slice(1))
    );
